import { Page } from "@/components/misc";
import { Card } from "@/components/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  CheckCircle2Icon,
  DatabaseIcon,
  LayoutTemplateIcon,
  PaletteIcon,
  ScaleIcon,
  VariableIcon,
} from "lucide-react";

export const Route = createFileRoute("/content/")({
  component: ContentDashboard,
});

const assets = [
  {
    to: "/content/schemas" as const,
    icon: DatabaseIcon,
    label: "Schemas",
    description: "Reusable parameter structures for templates",
  },
  {
    to: "/content/templates" as const,
    icon: LayoutTemplateIcon,
    label: "Templates",
    description: "Reusable content templates for experiment generation",
  },
  {
    to: "/content/styles" as const,
    icon: PaletteIcon,
    label: "Styles",
    description: "Tone, voice, and formatting guidelines",
  },
  {
    to: "/content/rules" as const,
    icon: ScaleIcon,
    label: "Rules",
    description: "Constraints and guardrails for content generation",
  },
  {
    to: "/content/variables" as const,
    icon: VariableIcon,
    label: "Variables",
    description: "Dynamic variable types for personalized content",
  },
  {
    to: "/content/evaluation" as const,
    icon: CheckCircle2Icon,
    label: "Evaluation",
    description: "Criteria for evaluating generated content quality",
  },
];

function ContentDashboard() {
  return (
    <Page size="large" className="space-y-6">
      <Page.TitleContainer>
        <div>
          <Page.Title>Content</Page.Title>
          <Page.Subtitle>
            Building blocks for draft experiment generation
          </Page.Subtitle>
        </div>
      </Page.TitleContainer>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {assets.map((asset) => (
          <Link key={asset.to} to={asset.to}>
            <Card className="transition-colors hover:border-primary/50 h-full">
              <Card.Header>
                <div className="flex items-center gap-2">
                  <asset.icon className="size-5 text-muted-foreground" />
                  <Card.Title>{asset.label}</Card.Title>
                </div>
                <Card.Description>{asset.description}</Card.Description>
              </Card.Header>
            </Card>
          </Link>
        ))}
      </div>
    </Page>
  );
}
